import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from '../../utils/useful'
import ButtonAnimated from '../buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';


export default class NotifInvitationRequestBox extends Component {
    state = {
        isLoadingHandle: {},
        data: {}
    }

    componentDidMount = () => {
        let data = this.props.data
        this.setState({ data })
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.data != this.props.data) {

            let data = this.props.data
            this.setState(data)

        }
    }


    handleRequest = (item, accept) => {



        let isLoadingHandle = this.state.isLoadingHandle ?? {}

        if (!isLoadingHandle[item._id]) {
            
            if(item.applet){

            isLoadingHandle[item._id] = accept ? '1' : '0'
            this.setState({ isLoadingHandle })

            let body = { _id: item.extra._id, notif: item._id, accept }
            HttpServices.request('handleAppletInvitationRequest', body, (fetchResult, fetchError) => {

                isLoadingHandle[item._id] = null
                this.setState({ isLoadingHandle })

                if (fetchError) {
                    // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                let data = this.state.data
                data.actionStatus = (accept ? 'A' : 'D')

                this.setState({ data })

            })

        }else{
            

            isLoadingHandle[item._id] = accept ? '1' : '0'
            this.setState({ isLoadingHandle })

            let body = { _id: item.extra._id, notif: item._id, accept }
            HttpServices.request('handleInvitationRequest', body, (fetchResult, fetchError) => {

                isLoadingHandle[item._id] = null
                this.setState({ isLoadingHandle })

                if (fetchError) {
                    // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                let data = this.state.data
                data.actionStatus = (accept ? 'A' : 'D')

                this.setState({ data })

            })


        }


        }

    }

    openHub = () => {
        let notif = this.state.data
        this.props.addNewWindow("hub", { path: [notif?.sender?.username], type: 'applet' }, "center")
    }

    openApplet = (applet) => {
        let notif = this.state.data
        this.props.addNewWindow("applet", { path: [notif?.sender?.username, applet.slug], type: 'applet' }, "center")
    }

    render() {
        // let type = this.state.type
        let notif = this.state.data
        let isPopupMessange = this.props.isPopupMessange


        return (
            <div className="py-2 px-2 w-100">
                {/* <button onClick={() => this.openHub()} className='flexc'>
                    <div className='flexcc mrd-2'>
                        <img src={imageAddress(notif?.sender?.image, 'profile', 'thumb')} height={26} width={26} className='br-20' alt='' />
                    </div>

                    <div className='text-start'>
                        <p className="font-size-12 text-semibold">{checkTranslation(notif?.sender?.fullname)}</p>
                    </div>
                </button> */}

                {notif.title && (

                    <div className='flexc mb-2'>
                        <p className="font-size-15 text-semibold">{checkTranslation(notif.title)}</p>
                    </div>

                )}


                {notif.applet && (

                    <div className='flexc mb-2'>
                        <button onClick={() => this.openApplet(notif?.applet)} className='flexc'>
                            <div className='flexcc mrd-1'>
                                <img src={imageAddress(notif?.applet?.image, 'applet', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                            </div>
                        </button>


                        <button onClick={() => this.openApplet(notif?.applet)}>
                            <p className="font-size-13 text-bold">{checkTranslation(notif?.applet?.name)}</p>
                        </button>
                    </div>

                )}


                <div className='flexc'>
                    <button onClick={() => this.openHub(notif?.sender)} className='flexc'>
                        <div className='flexcc mrd-1'>
                            <img src={imageAddress(notif?.sender?.image, 'profile', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                        </div>
                    </button>

                    <div className='flexcc mrd-1'>
                        <img src={'/assets/icons/useful/link (4).png'} height={16} width={16} className='br-20 opacity-5' alt='' />
                    </div>

                    <button onClick={() => this.openHub(notif?.hub)} className='flexc'>
                        <div className='flexcc '>
                            <img src={imageAddress(notif?.hub?.image, 'profile', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                        </div>
                    </button>
                </div>

                <div className='flexc mt-1 flex-1'>


                    <div className='text-start flexc flex-1 w-100'>

                        <button className='mrd-2 text-start' style={{ maxWidth: '45%', minWidth: 0 }} onClick={() => this.openHub(notif?.sender)}>
                            <p className="font-size-13 text-bold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: 0, overflow: 'hidden' }}>{checkTranslation(notif?.sender?.fullname)}</p>
                        </button>

                        <div className='flexcc mrd-2'>
                            <img src={'/assets/icons/useful/link (4).png'} height={16} width={16} className='br-20 opacity-5' alt='' />
                        </div>

                        <button className='text-start' style={{ maxWidth: '45%', minWidth: 0 }} onClick={() => this.openHub(notif?.hub)}>
                            <p className="font-size-13 text-bold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: 0, overflow: 'hidden' }}>{checkTranslation(notif?.hub?.fullname)}</p>
                        </button>

                    </div>
                </div>



                <div className='mt-1 mb-2'>
                    {notif?.message && (<p className=" text-semibold" style={{ fontSize: isPopupMessange ? 14 : 12 }}>{checkTranslation(notif?.message)}</p>)}
                </div>


                {Array.isArray(notif.groups) && notif.groups.filter((a) => !a.hidden).length > 0 && (
                    <div className="flexc mt-1">
                        {notif.groups.map((group, k) => {
                            if (!group.hidden) {
                                return (
                                    <div className="mrd-2 br-20 px-2 py-1 text-smaller" key={group._id} style={{ backgroundColor: '#007aff15', color: '#007aff' }}>
                                        <p>{group.name}</p>
                                    </div>
                                )
                            }
                        })}
                    </div>
                )}

                <div className={"" + (isPopupMessange ? 'flexce' : 'flexc')}>

                    {notif.actionStatus == 'D' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#ee5050', backgroundColor: "#ee505020" }}>
                            <p className={"text-semibold " + (isPopupMessange ? 'font-size-13' : 'font-size-12')}>{translate("Declined")}</p>
                        </div>

                    )}

                    {notif.actionStatus == 'A' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#007aff', backgroundColor: "#007aff20" }}>
                            <p className={"text-semibold " + (isPopupMessange ? 'font-size-13' : 'font-size-12')}>{translate("Accepted")}</p>
                        </div>

                    )}

                    {notif.actionStatus == null && (
                        <div className='flexc'>
                            <div className="flexcc mrd-2">
                                <ButtonAnimated
                                    onClick={() => this.handleRequest(notif, false)}
                                    title={translate('Decline')}
                                    isLoading={this.state?.isLoadingHandle[notif._id] == '0'}
                                    textColor={'#777'}
                                    bg={'#e0e0e0'}
                                    fontSize={!isPopupMessange ? 12 : 14}
                                // width={'100%'}
                                />
                            </div>
                            <div className="flexcc">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.handleRequest(notif, true)}
                                    title={translate('Accept')}
                                    icon='/assets/icons/check-white.svg'
                                    textColor={'#fff'}
                                    fontSize={!isPopupMessange ? 12 : 14}
                                    isLoading={this.state?.isLoadingHandle[notif._id] == '1'}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                                />
                            </div>

                        </div>
                    )}
                </div>
            </div>
        )
    }
}

